import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE,LOGOUT_USER,
   LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN, } from './actionTypes';

export const loginRequest = (login, history) => ({
  type: LOGIN_REQUEST,
  payload: { login, history },
});

export const loginSuccess = (token,menu) => ({
  type: LOGIN_SUCCESS,
  payload: { token,menu },
});

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: { error },
});
export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (type, history) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { type, history },
  };
};